import React from "react";

import { IconButton } from "@mui/material";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import { SearchNormal1 as IconSearch, ArrowLeft as IconArrowLeft } from "iconsax-react";

export const DiaryHeaderSearchButton = () => {
  const { isSearchMode, setIsSearchMode } = useOperationDespatchContext();

  return (
    <IconButton
      onClick={() => setIsSearchMode(!isSearchMode)}
      size="large"
      color="inherit"
      style={{
        marginLeft: !isSearchMode ? "auto" : undefined,
        marginRight: isSearchMode ? "12px" : undefined,
      }}
    >
      {isSearchMode ? <IconArrowLeft size={20} /> : <IconSearch size={20} />}
    </IconButton>
  );
};
